import { isDefined } from "@clipboard-health/util-ts";
import { createContext, useContext } from "react";

import { type FcmApprovalStatus } from "../utils/parseFcmRequestMessage";

export interface FcmRequestActionIntent {
  action: "approve" | "reject";
  approvalStatus: FcmApprovalStatus;
  messageId: string;
  shiftId: string;
  timeZone: string;
  workerId?: string;
  workerName: string;
  workplaceId: string;
  workplaceUserId?: string;
}

interface FcmRequestDialogHostValue {
  openDialog: (intent: FcmRequestActionIntent) => void;
}

export const FcmRequestDialogContext = createContext<FcmRequestDialogHostValue | undefined>(
  undefined
);

export function useFcmRequestDialogHost(): FcmRequestDialogHostValue {
  const context = useContext(FcmRequestDialogContext);

  if (!isDefined(context)) {
    throw new Error("useFcmRequestDialogHost must be used within FcmRequestDialogHost");
  }

  return context;
}
